export default __webpack_public_path__ + "static/media/Anamnesis questions.046c7a2b.png";